import { validateName } from "./Validations/validateName";

export async function validateAddProgress() {
    //let elementDate = document.getElementById('inputDate');
    
    //elementDate.setCustomValidity(elementDate.value);

}